import React, { useState } from "react";
import faqdropdown from "../../images/faqdropdown.png";
import Footer from "../../component/footer/Footer";

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: 'What Services do you offer?', answer: 'We offer a range of logistics services' },
    { question: 'What are your rates?', answer: 'Our rates vary depending on the service you need and the distance of the delivery. You can check our rates on the app or contact us for a quote.' },
    { question: 'What if I have a problem with my delivery?', answer: 'If you have any issues with your delivery, please contact our customer support team through the app. We will do our best to resolve the issue as quickly as possible.' },
    { question: 'How do you ensure the safety of my goods during transportation?', answer: 'We take the safety of your goods very seriously. Our Riders/drivers are trained to handle cargo safely, and we use secure packaging and loading techniques for your peace of mind.' },
    { question: 'How do I book your services?', answer: 'You can easily book our services through our app. Simply download the app, create an account, and select the service you need.' },
    { question: 'How do I track my delivery?', answer: 'You can track your delivery in real-time through our app. You will receive updates on the status of your delivery, including when it has been picked up and when it will be delivered.' },
    { question: 'What are the different means of delivery?', answer: 'We have a variety of vehicles available for transportation, including Motor Bikes, Cars and Vans. We can ccommodate different sizes and types of cargo. Active means of delivery are available on the app.' },
    { question: 'What areas do you serve?', answer: 'We serve locally within Nigeria, You can check our service areas on the app or contact us for more information on service coverage.' },
    { question: 'What payment methods do you accept?', answer: 'We accept online payment with credit cards/debit card method on the app.' },
    { question: 'How do I provide special instructions for my delivery?', answer: 'You can provide special instructions for your delivery through the app. For example, you can specify the delivery location or provide contact information for the recipient.' },
    { question: 'How do I know when my delivery has been completed?', answer: 'You will receive a notification through the app when your delivery has been completed. You can also track the status of your delivery in real-time.' },
    { question: 'What is your delivery time frame?', answer: 'Our delivery time frame depends on the service you choose and the distance of the delivery. We offer same-day and scheduled deliveries. You can check the estimated delivery time on the app.' },
    { question: 'Do you offer any discounts or promotions?', answer: 'Yes, we offer various discounts and promotions from time to time. You can check for any current promotions on the app or contact us for more information.' },
    { question: 'How do I provide feedback on my experience?', answer: 'We welcome your feedback on your experience with our services. You can provide feedback through the app or contact our customer support team. We appreciate your input and use it to improve our services.' },
    { question: 'What if I need to change my delivery details?', answer: 'You can change your delivery details through the app only before making payment. Kindly go through your booking summaries before making payment. However knidly contact Pickload Customer support for assistance.' },
    { question: 'How do I know if my delivery is delayed?', answer: 'If your delivery is delayed for any reason, we will notify you through the app. We will also provide updates on the status of your delivery and an estimated time of arrival.' },
    { question: 'What is the maximum weight and size for deliveries?', answer: 'The maximum weight and size for deliveries depends on the capacity of the vehicle being used and the distance of the delivery.' },
    { question: 'How do you ensure the safety of my package during delivery?', answer: 'We take the safety of your package very seriously. Our couriers are trained to handle packages safely, and we use secure packaging and loading techniques.' },
    { question: 'What if I need to cancel my delivery?', answer: 'You can ONLY cancel Scheduled Bookings; cancellation does not apply for instant delivery booking. However, please note that cancellation fees applies.' },
    { question: 'How do I track my delivery?', answer: 'You can track your delivery in real-time through the app. You will receive updates on the status of your delivery, including when it has been picked up and when it will be delivered.' },
    { question: 'How long does it take to get my refund on cancelled booking?', answer: 'You get refund within 3 to 5 business working days.' },
    { question: 'What if I have a question that is not answered on the app?', answer: 'If you have a question that is not answered on the app, you can contact our customer support team. We are available to assist you with any questions or concerns you may have.' },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white  pt-16 flex flex-col items-center">

      {/* Title */}
      <h1 className="text-3xl font-bold mx-4 mb-10 text-gray-900">
        Frequently Asked Questions
      </h1>

      {/* FAQ Container */}
      <div className="w-full max-w-3xl space-y-4">

        {faqs.map((faq, index) => {
          const isOpen = activeIndex === index;

          return (
            <div
              key={index}
              className="bg-white border mx-4 border-gray-200 rounded-xl shadow-sm overflow-hidden transition-all duration-300"
            >
              {/* Question */}
              <button
                onClick={() => toggleAnswer(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="text-gray-800 font-medium">
                  {faq.question}
                </span>

                <img
                  src={faqdropdown}
                  alt="toggle"
                  className={`w-4 h-4 transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"
                    }`}
                />
              </button>

              {/* Answer (animated) */}
              <div
                className={`px-5 text-gray-600 text-sm leading-relaxed transition-all duration-300 ease-in-out ${isOpen
                    ? "max-h-40 opacity-100 pb-4"
                    : "max-h-0 opacity-0 overflow-hidden"
                  }`}
              >
                {faq.answer}
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="w-full mt-20">
        <Footer />
      </div>
    </div>
  );
};

export default FAQs;